module.exports = __webpack_public_path__ + "img/products_big_can_bubblegum_ru.c9b92fc8.png";